import { IFormSateProvider, IFormStateContext } from './formSateProvider.types';
import { createContext, useMemo, useState } from 'react';

export const FormStateContext = createContext<IFormStateContext>({
  isFormValid: false,
  setIsFormValid: null,
});

export const FormStateProvider = (props: IFormSateProvider) => {
  const [isFromValid, setIsFormValid] = useState(false);

  const contextValue = useMemo(() => {
    return {
      isFormValid: isFromValid,
      setIsFormValid,
    };
  }, [isFromValid]);

  return (
    <>
      <FormStateContext.Provider value={contextValue}>{props.children}</FormStateContext.Provider>
    </>
  );
};
